export const TRACKING_KEY = 'tracking';
export const VIEW = `${TRACKING_KEY}/view`;
export const TRACK_SET_PLAYER_DATA = `${TRACKING_KEY}/TRACK_SET_PLAYER_DATA`;
export const TRACK_GET = `${TRACKING_KEY}/TRACK_GET`;
export const TRACK_GOT = `${TRACKING_KEY}/TRACK_GOT`;
export const TRACK_ERROR = `${TRACKING_KEY}/TRACK_ERROR`;
export const TRACK_ADD = `${TRACKING_KEY}/TRACK_ADD`;
export const TRACK_CHANGE = `${TRACKING_KEY}/TRACK_CHANGE`;
export const TRACK_DELETE = `${TRACKING_KEY}/TRACK_DELETE`;
export const TRACK_DELETE_LEAGUE = `${TRACKING_KEY}/TRACK_DELETE_LEAGUE`;
export const TRACK_BEGIN_UPDATE = `${TRACKING_KEY}/BEGIN_UPDATE`;
export const TRACK_END_UPDATE = `${TRACKING_KEY}/END_UPDATE`;
export const TRACK_UPDATE_ERROR = `${TRACKING_KEY}/UPDATE_ERROR`;



// WEBPACK FOOTER //
// ./src/store/actions/tracking.types.js